module.exports = __webpack_public_path__ + "static/media/tick.9c447a86.svg";